
import { useAuth } from "@/context/AuthContext";
import { useOrganization } from "@/context/OrganizationContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { fetchComponentTypes } from "@/utils/componentService";
import { createComponentType } from "@/utils/services/componentTypeService";
import { createComponent } from "@/utils/componentService";

export function useSidebarActions(
  subscriptionData: any,
  currentOrganization: any,
  refreshComponents?: () => Promise<void>,
  setIsSaving?: (saving: boolean) => void,
  setCreateTypeDialogOpen?: (open: boolean) => void,
  setCreateComponentDialogOpen?: (open: boolean) => void,
  setComponentTypes?: (types: any[]) => void,
  setLoadingComponentTypes?: (loading: boolean) => void
) {
  const navigate = useNavigate();

  const loadComponentTypes = async () => {
    if (!subscriptionData?.subscription_id || !setLoadingComponentTypes || !setComponentTypes) return;
    
    setLoadingComponentTypes(true);
    try {
      const types = await fetchComponentTypes(subscriptionData.subscription_id);
      setComponentTypes(types);
    } catch (error) {
      console.error("Erro ao carregar tipos de componentes:", error);
      toast.error("Erro ao carregar tipos de componentes");
    } finally {
      setLoadingComponentTypes(false);
    }
  };

  const handleCreateComponentType = async (name: string, icon: string | null, groupName: string | null) => {
    if (!setIsSaving || !setCreateTypeDialogOpen) return;
    
    setIsSaving(true);
    try {
      const result = await createComponentType(name, icon, groupName, subscriptionData?.subscription_id);
      
      if (result) {
        if (refreshComponents) {
          await refreshComponents();
        }
        setCreateTypeDialogOpen(false);
        toast.success("Tipo de componente criado com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao criar tipo de componente:", error);
      toast.error("Erro ao criar tipo de componente");
    } finally {
      setIsSaving(false);
    }
  };

  const handleCreateComponent = async (name: string, componentTypeId: string, repoType: string, repoName: string, repoUrl: string, mainUrl: string, logsUrl: string, dashUrl: string, swaggerUrl: string) => {
    if (!currentOrganization?.id || !setIsSaving || !setCreateComponentDialogOpen) {
      toast.error("Nenhuma organização selecionada");
      return;
    }
    
    setIsSaving(true);
    try {
      const result = await createComponent(name, componentTypeId, currentOrganization.id, repoType, repoName, repoUrl, mainUrl, logsUrl, dashUrl, swaggerUrl);
      
      if (result.success) {
        if (refreshComponents) {
          await refreshComponents();
        }
        setCreateComponentDialogOpen(false);
        toast.success("Componente criado com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao criar componente:", error);
      toast.error("Erro ao criar componente");
    } finally {
      setIsSaving(false);
    }
  };

  const handleAddNew = () => {
    loadComponentTypes();
    if (setCreateComponentDialogOpen) {
      setCreateComponentDialogOpen(true);
    }
  };

  const handleBack = () => {
    navigate('/diagramas');
  };

  return {
    loadComponentTypes,
    handleCreateComponentType,
    handleCreateComponent,
    handleAddNew,
    handleBack,
  };
}
